import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../globals';
import Popover from '../Popover';
import PopoverContentAssembly from '../PopoverContentAssembly';

const LinkWrapper = styled.div`
    width:100%;
    text-align: center;
    margin-top: -50px;
    padding-bottom: 20px;
    
    ${media.md` 
        text-align: right;
     `}
`;

const Link = styled.a` 
  display: inline-block;
  width: 100%;
  height: 100%;
  font-size: 13px !important;
  box-sizing: border-box;
  text-decoration: none;
  color: #00729E;
`;

const ReceiptSearchHelper = (props) => {
    const _popoverProps = {
        id: 'receipt_search_instructions',
        triggerWidth: props.width,
        popover: {
            content: <PopoverContentAssembly {...props} />,
            backgroundColor: '#fff'
        }
    };

    return (
        <LinkWrapper>
            <Popover {..._popoverProps}>
                <Link>
                    {props.linkText}
                </Link>
            </Popover>
        </LinkWrapper>
    );
};

ReceiptSearchHelper.propTypes = {
    linkText: PropTypes.string,
    width: PropTypes.string,
    getLocalizedText: PropTypes.func.isRequired,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

ReceiptSearchHelper.defaultProps = {
    linkText: '',
    width: '100%',
    getLocalizedText: (key, defaultValue) => defaultValue,
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default ReceiptSearchHelper;



// WEBPACK FOOTER //
// ./src/components/ReceiptSearchHelper/index.js